import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints,
} from "@angular/cdk/layout";
import { Location } from "@angular/common";
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subscription } from "rxjs";
import { ApiService } from "src/app/shared/services";
import { EnvService } from "src/app/shared/services/env.service";
declare var google: any;

@Component({
  selector: "app-view-project-intake-form",
  templateUrl: "./view-project-intake-form.component.html",
  styleUrls: ["./view-project-intake-form.component.less"],
})
export class ViewProjectIntakeFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() data: any;
  @Input() projectData: any;
  isHandset: boolean;
  buttonSelected = 0;
  bpSubscription: Subscription;
  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  styleData: any;
  deviceHeight: number;
  projectImages: any;
  room: any;
  roomId: any;
  homeList: any[] = [];
  changesList: { field: string; label: string; old_value: string; new_value: string; }[] = [];
  zipCodeError: boolean = false;
  isZipLoading: boolean = false;

  zipLocation: any = null;

  zipMap: any;

  constructor(
    private api: ApiService,
    private actRou: ActivatedRoute,
    private router: Router,
    private location: Location,
    private breakpointObserver: BreakpointObserver,
    private env: EnvService
  ) { }
  ngOnDestroy(): void {
    this.api.onInitLoaded = false;
  }

  getRoomProfileChanges() {
    this.api.getRoomProfileChanges(this.api.roomId).subscribe((res: any) => {
      //             this.changesList = [
      //   {
      //     "field": "room_likes",
      //     "label": "Room Likes",
      //     "old_value": "minimal",
      //     "new_value": "everything"
      //   },
      //   {
      //     "field": "style_identity",
      //     "label": "Style Identity",
      //     "old_value": "country, boho, rustic",
      //     "new_value": "country, boho, rustic, european"
      //   }
      // ] 
      if (res.changes && res.changes.length > 0) {


      }

    })
  }

  get roomLikes(): any {
    let data = this.changesList.find(f => f.field === 'room_likes');
    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }

  get roomDislikes(): any {
    let data = this.changesList.find(f => f.field === 'room_dislikes');
    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }

  get roomUse(): any {
    let data = this.changesList.find(f => f.field === 'room_use');
    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }

  get roomOccupants(): any {
    let data = this.changesList.find(f => f.field === 'room_occupants');
    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }

  get prefBrands(): any {
    let data = this.changesList.find(f => f.field === 'preferred_brands');
    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }

  get roomPriorities(): any {
    let data = this.changesList.find(f => f.field === 'room_priorities');

    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }

  get roomMood(): any {
    let data = this.changesList.find(f => f.field === 'room_mood');
    if (data) {
      return { ...data, isChange: true }
    } else {
      return { ...this.data, isChange: false }
    }
  }
  markSeen() {
    this.api.markRoomProfileChangesSeen(this.roomId).subscribe();
  }



  scrollTop() {
    // window.scrollTo({
    //   top: 0,
    //   behavior: 'smooth'
    // });
    document.getElementById('msggContainer')?.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  reloadPage() {
    this.api.onInitLoaded = false;
    this.ngOnInit();
  }
  get innerWidth(): number {
    return window.innerWidth
  }
  ngOnInit(): void {
    this.deviceHeight = window.innerHeight;
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
        console.log(this.isHandset, 'ISHANDA')
      }
    );
    this.homeList = [
      {
        name: "Urban House",
        image: this.env.assetBaseUrl + "site/quiz/034-duplex.png",
        value: "urban_home",
      },
      {
        name: "Apartment",
        value: "apartment",
        image: this.env.assetBaseUrl + "site/quiz/035-apartment.png",
      },
      {
        name: "Suburban House",
        value: "suburban_home",
        image: this.env.assetBaseUrl + "site/quiz/036-house.png",
      },
      {
        name: "Farmhouse/Lodge",
        image: this.env.assetBaseUrl + "site/quiz/037-farmhouse.png",
        value: "country",
      },
    ];
    if (!this.api.onInitLoaded) {

      this.api.roomId = this.actRou.snapshot.params.id;
      this.roomId = this.api.roomId;
      this.getDesignProject();
      this.getProjectIntakeDropdowns();
      this.getDesignNotes();
      this.getRoomProfileChanges();
      this.api.onInitLoaded = true;
      if (this.location.path().includes("profile")) {
        this.buttonSelected = 1;
        this.markSeen();
      } else if (this.location.path().includes("files")) {
        this.buttonSelected = 2;
      } else if (this.location.path().includes("designs")) {
        this.buttonSelected = 3;
      } else if (this.location.path().includes("shopping-list")) {
        this.buttonSelected = 4;
      } else if (this.location.path().includes("pinterest")) {
        this.buttonSelected = 5;
      } else if (this.location.path().includes("contact-log")) {
        this.buttonSelected = 6;
      } else if (this.location.path().includes("design-history")) {
        this.buttonSelected = 7;
      } else if (this.location.path().includes("notes")) {
        this.buttonSelected = 8;
      }
      else if (this.location.path().includes("specs")) {
        this.buttonSelected = 9;
      }
      // this.api.getAllAppointments("", this.api.roomId).subscribe((res) => {
      //   if (res && res.length > 0) {
      //     this.projectData = res[0];
      //     this.projectData.tasks_summary = true;
      //     this.projectData.tasks_vision = true;
      //     this.projectData.tasks_upload = true;
      //   }
      // });

    }
  }
  notesCount: number | null = null;
  getDesignNotes() {
    this.api.getNotes(this.roomId).subscribe((res: any) => {
      this.notesCount = res.length;
    });
  }

  metalsList: any = [];
  colorsList: any = [];
  styleList: any = [];
  getProjectIntakeDropdowns() {
    this.api.getProjectIntakeDropdowns().subscribe((resp: any) => {

      this.metalsList = resp.metals;
      this.colorsList = resp.colors;
      this.styleList = resp.style;
      this.getDesignIntake();
    });
  }


  getStyleReport() {
    this.api.getStyleReport(this.projectData.style_quiz_id).subscribe((res: any) => {
      console.log(res, 're')
      if (res.genome && res.genome.length > 0)
        this.styleData = res.genome[0];
    })
  }
  getDesignIntake() {
    this.api.getDesignIntake(this.api.roomId).subscribe((resp: any) => {

      if (resp && resp.length > 0) {

        resp[0].style_identity = resp[0].style_identity
          ? resp[0].style_identity.split(",")
          : [];
        resp[0].style_colors = resp[0].style_colors
          ? resp[0].style_colors.split(",")
          : [];
        resp[0].style_metals = resp[0].style_metals
          ? resp[0].style_metals.split(",")
          : [];

        resp[0].style_identity = resp[0].style_identity.map((f: any) => {
          const found = this.styleList.find((s: any) => s.value === f);
          return found ? found.label : f;
        });
        resp[0].style_colors = resp[0].style_colors.filter((t: any) => t !== 'Other').map((f: any) => {
          const found = this.colorsList.find((s: any) => s.value === f);
          return { label: found ? found.label : f, image: found ? found.image : '' };
        });
        console.log('metalslist', resp[0].style_colors)
        resp[0].style_metals = resp[0].style_metals.filter((t: any) => t !== 'Other').map((f: any) => {
          const found = this.metalsList.find((s: any) => s.value === f);
          return { label: found ? found.label : f, image: found ? found.image : '' };
        });

        this.data = resp[0];
        this.onZipCodeInput();

      }
    });
  }

  designHistoryList: any[] = [];
  totalDesignRecords: number;
  getAllDesignBookingsByStatusEmail() {
    this.api.getAllDesignBookingsByStatusEmail('02,03,04,09', this.projectData.email, 0).subscribe((res: any) => {
      console.log(res, 'bookings')
      this.designHistoryList = res.data.filter(f => f.room_id !== +this.api.roomId);
      this.totalDesignRecords = res.total;
    });
  }

  getDesignProject() {
    this.api.getDesignProject(this.api.roomId).subscribe((resp: any) => {
      if (resp && resp.length > 0) {
        this.projectImages = resp;
        this.projectData = resp[0]
        this.room = resp[0].room;
        this.getAllDesignBookingsByStatusEmail();
      }
      this.getStyleReport();


    });
  }

  get getRoomVal(): string {
    return this.api.getRoomValue(this.room);
  }

  get deliverySpeed(): { text: string; color: string } {
    return this.api.getDeliveryValue(this.data?.delivery_speed);
    // if (this.data?.delivery_speed) {
    //   return this.data.delivery_speed === 'asap'
    //     ? 'ASAP'
    //     : this.toTitleCase(this.data.delivery_speed);
    // }
    // return '';
  }

  private toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }


  buttonClick(c) {

    this.buttonSelected = c;
    if (c == 1) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/profile`
      );
      this.markSeen();

    } else if (c == 2) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/files`
      );
    } else if (c == 3) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/designs`
      );
    } else if (c == 4) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/shopping-list`
      );
    } else if (c == 5) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/pinterest`
      );

    } else if (c == 6) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/contact-log`
      );

    } else if (c == 7) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/design-history`
      );

    } else if (c == 8) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/notes`
      );

    }
    else if (c == 9) {
      this.location.replaceState(
        `admin/dashboard/design/rooms/${this.api.roomId}/specs`
      );

    }
  }
  openReport(d) {
    this.router.navigate([]).then(() => {
      window.open(`/style-quiz/my-style/${d.style_quiz_id}`);
    });
  }
  goToclient() {
    this.router.navigate([]).then(() => {
      window.open(`/design/rooms/${this.roomId}/designs`);
    });
  }
  showEditPage() {
    this.router.navigate([`/admin/dashboard/design/rooms`]);
  }
  ngAfterViewInit(): void {
    this.hideIntercomIcon()
  }
  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);
    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }
  inchToFeetInches(inchString: string): string {
    const totalInches = parseFloat(inchString);

    // Calculate feet and remaining inches
    const feet = Math.floor(totalInches / 12);
    const inches = Math.floor(totalInches % 12);

    return `${feet}' ${inches}"`;
  }

  getHome(p) {
    if (p) {
      return this.homeList.find(f => f.value === p.home_type)?.name
    } else {
      return '';
    }
  }
  onZipCodeInput(): void {

    this.zipCodeError = false;

    if (!this.data.ship_zip_code) {
      this.zipLocation = null;
      return;
    }

    const zipRegex = /^\d{5}$/;

    if (this.data.ship_zip_code.length === 5) {

      if (!zipRegex.test(this.data.ship_zip_code)) {
        this.zipCodeError = true;
        return;
      }

      this.lookupZipCode(this.data.ship_zip_code, true);
    }
  }

  // =========================================
  // GOOGLE GEOCODER
  // =========================================

  lookupZipCode(
    zip: string,
    closeEditMode: boolean = true
  ): void {
    if (!(window as any)['google'] || !google.maps) {
      return;
    }

    this.isZipLoading = true;

    const geocoder = new google.maps.Geocoder();

    geocoder.geocode(
      {
        address: zip,
        componentRestrictions: {
          country: 'US',
          postalCode: zip
        }
      },
      (results: any, status: any) => {

        this.isZipLoading = false;
        if (status === 'REQUEST_DENIED') {
          this.zipCodeError = false;
          return;
        }

        if (
          status !== 'OK' ||
          !results ||
          !results.length
        ) {
          this.zipCodeError = true;
          return;
        }

        const result = results[0];

        const postalCode = this.getAddressComponent(
          result,
          'postal_code',
          true
        );

        if (postalCode !== zip) {
          this.zipCodeError = true;
          return;
        }

        const city =
          this.getAddressComponent(result, 'locality') ||
          this.getAddressComponent(result, 'postal_town') ||
          this.getAddressComponent(result, 'sublocality') ||
          this.getAddressComponent(result, 'administrative_area_level_2');

        // 2 LETTER STATE CODE
        const state =
          this.getAddressComponent(
            result,
            'administrative_area_level_1',
            true
          );

        const lat = result.geometry.location.lat();
        const lng = result.geometry.location.lng();

        this.zipLocation = {
          city,
          state,
          lat,
          lng
        };

        this.zipCodeError = false;



        setTimeout(() => {
          this.renderZipMap(lat, lng);
        });

      }
    );
  }

  // =========================================
  // ADDRESS PARSER
  // =========================================

  getAddressComponent(
    result: any,
    type: string,
    shortName: boolean = false
  ): string {

    const component =
      result.address_components.find(
        (c: any) => c.types.includes(type)
      );

    if (!component) return '';

    return shortName
      ? component.short_name
      : component.long_name;
  }


  // =========================================
  // MAP PREVIEW
  // =========================================

  renderZipMap(lat: number, lng: number): void {

    if (!(window as any)['google'] || !google.maps) {
      return;
    }

    const mapElement =
      document.getElementById('zip-map-preview');

    if (!mapElement) return;

    mapElement.innerHTML = '';

    this.zipMap = new google.maps.Map(mapElement, {

      center: { lat, lng },

      zoom: 15,

      disableDefaultUI: true,

      zoomControl: true,

      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },

      draggable: false,
      scrollwheel: false,
      clickableIcons: false,
      gestureHandling: 'none'
    });

    new google.maps.Marker({
      position: { lat, lng },
      map: this.zipMap
    });
  }
}